import * as React from "react";

function FlowAdvanceIcon(props) {
	return (
		<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M5.75 5.75L10 10L5.75 14.25"
				stroke="currentColor"
				strokeWidth="2.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.25 5.75L14.5 10L10.25 14.25"
				stroke="currentColor"
				strokeWidth="2.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default FlowAdvanceIcon;
